import Vue from 'vue';
import OpenServicesErrorsComponent from '@bizpal/open-services-errors-component';
import OpenServicesFooterComponent from '@bizpal/open-services-footer-component';
import OpenServicesNaicsLookup from '@bizpal/open-services-naics-lookup';
import OpenServicesSgcLookup from '@bizpal/open-services-sgc-lookup';
import interaction from '@bizpal/open-services-interaction-mixins';
import JsonExcel from 'vue-json-excel';
import Vuex, { mapGetters, mapMutations, mapActions } from 'vuex';
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faExclamationCircle, faChevronCircleDown, faChevronCircleUp, faTable, faFrown, faDownload, faArrowUp, faArrowDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import 'buefy/dist/buefy.css';
import { Notification, Collapse, Table, Checkbox, Tooltip, Icon, ConfigProgrammatic } from 'buefy';
import VueI18nWage from 'vue-i18n';

var state = (() => ({
  input: {
    mainSgc: {
      name: "",
      code: ""
    },
    mainNaics: {
      name: "",
      code: ""
    },
    compare: {
      sgc: {
        name: "",
        code: ""
      },
      naics: {
        name: "",
        code: ""
      }
    }
  },
  wage: [],
  minimumWage: {
    "10": "14.50",
    "11": "14.50",
    "12": "14.50",
    "13": "14.75",
    "24": "15.25",
    "35": "15.50",
    "46": "14.15",
    "47": "13.00",
    "48": "15.00",
    "59": "15.65",
    "60": "16.77",
    "61": "15.20",
    "62": "16.00"
  },
  provLookupEn: {
    "1": "Canada",
    "10": "Newfoundland and Labrador",
    "11": "Prince Edward Island",
    "12": "Nova Scotia",
    "13": "New Brunswick",
    "24": "Quebec",
    "35": "Ontario",
    "46": "Manitoba",
    "47": "Saskatchewan",
    "48": "Alberta",
    "59": "British Columbia",
    "60": "Yukon",
    "61": "Northwest Territories",
    "62": "Nunavut"
  },
  provLookupFr: {
    "1": "Canada",
    "10": "Terre-Neuve-et-Labrador",
    "11": "Île-du-Prince-Édouard",
    "12": "Nouvelle-Écosse",
    "13": "Nouveau-Brunswick",
    "24": "Québec",
    "35": "Ontario",
    "46": "Manitoba",
    "47": "Saskatchewan",
    "48": "Alberta",
    "59": "Colombie-Britannique",
    "60": "Yukon",
    "61": "Territoires de Nord-Ouest",
    "62": "Nunavut"
  },
  noData: false,
  error: false
}));

var mutations = {
  updateWage(state, payload) {
    Vue.set(state.wage, 0, payload);
  },

  updateMainInput(state, {
    key,
    payload
  }) {
    Vue.set(state.input, key, payload); // reset compare values

    Vue.set(state.input, "compare", {
      sgc: {
        name: "",
        code: ""
      },
      naics: {
        name: "",
        code: ""
      }
    });
  },

  updateCompareInput(state, {
    key,
    payload
  }) {
    // don't update if payload is undefined
    if (payload.code === undefined) ; else {
      Vue.set(state.input["compare"], key, payload);
    }
  },

  resetCompareInput(state) {
    if (state.input.compare.sgc.code == "" && state.input.compare.naics.code == "") ; else {
      Vue.set(state.input, "compare", {
        sgc: {
          name: "",
          code: ""
        },
        naics: {
          name: "",
          code: ""
        }
      });
    }
  },

  updateNoData(state, payload) {
    state.noData = payload;
  },

  updateError(state, payload) {
    state.error = payload;
  }

};

function getConnexion(payload, url, user, pwd) {
  //console.log("req");
  //console.log(payload.req)
  return axios({
    method: "post",
    url: url,
    auth: {
      username: user,
      password: pwd
    },
    data: {
      statements: [{
        statement: payload.req
      }]
    }
  }).then(response => response.data);
}

function copyWageData(finalResult, naicsCodeObj, dataAPI) {
  // using single quote to prevent javascript to order sgc/naics code
  // in order to show compare table/columns properly
  let mainNaicsCode = `'${parseInt(naicsCodeObj.code)}'`;
  finalResult[mainNaicsCode] = {};
  finalResult[mainNaicsCode].id = Date.now() + Math.random(); // to create unique id for b-table refresh

  finalResult[mainNaicsCode].sgc = {};
  finalResult[mainNaicsCode].wage_data = {};
  finalResult[mainNaicsCode].naics = naicsCodeObj;
  const entries = Object.entries(dataAPI);

  for (const [naicsCode, data] of entries) {
    // this is required to remove single quote before doing regular expression
    // test.
    var searchPattern = new RegExp("^" + mainNaicsCode.split("'").join(""));

    if (searchPattern.test(naicsCode.split("'").join(""))) {
      // eslint-disable-next-line prettier/prettier
      finalResult[mainNaicsCode].sgc = Object.keys(data.sgc).length > Object.keys(finalResult[mainNaicsCode].sgc).length ? data.sgc : finalResult[mainNaicsCode].sgc;
      let wageDataAPI = data.wage_data;
      Object.keys(wageDataAPI).forEach(key => {
        wageDataAPI[key].map(function (element) {
          if (finalResult[mainNaicsCode].wage_data[key] === undefined) {
            finalResult[mainNaicsCode].wage_data[key] = [];
          }

          finalResult[mainNaicsCode].wage_data[key].push(element);
        });
      });
    }
  } //for


  return finalResult;
}

function setObjWhenNoData(context, InputObj, data, naicCode, flag) {
  // eslint-disable-next-line prettier/prettier
  if (data[`'${naicCode}'`].wage_data[`'${InputObj.compare.sgc.code}'`] === undefined) {
    context.commit("updateNoData", true);
    data[`'${naicCode}'`].wage_data[`'${InputObj.compare.sgc.code}'`] = {};
    data[`'${naicCode}'`].sgc[InputObj.compare.sgc.code] = {
      code: InputObj.compare.sgc.code,
      title_en: InputObj.compare.sgc.name.split(",")[0],
      title_fr: InputObj.compare.sgc.name.split(",")[0] // since coming from lookup, only have one language

    }; // since industry had to add data for main sgc as well

    if (flag == "industry") {
      // eslint-disable-next-line prettier/prettier
      if (data[`'${naicCode}'`].wage_data[`'${InputObj.mainSgc.code}'`] === undefined) {
        data[`'${naicCode}'`].wage_data[`'${InputObj.mainSgc.code}'`] = {};
        data[`'${naicCode}'`].sgc[InputObj.mainSgc.code] = {
          code: InputObj.mainSgc.code,
          title_en: InputObj.mainSgc.name.split(",")[0],
          title_fr: InputObj.mainSgc.name.split(",")[0] // since coming from lookup, only have one language

        };
      }
    }
  }

  return data;
}

const Wage = {
  getResults: function (context, payload, url, user, pwd) {
    getConnexion(payload, url, user, pwd).then(response => {
      var dataAPIreformatted = {};
      context.commit("updateNoData", false); // turn off Alert
      //console.log("aftergettingdata");
      //console.log(payload)
      // create data structure from API result

      for (var i = 0; i < response.results[0].data.length; i++) {
        let dataAPI = response.results[0].data[i].row; // using single quote to prevent javascript to order sgc/naics code
        // in order to show compare table/columns properly

        let naicsCode = `'${dataAPI[0].naics_code}'`;

        if (dataAPIreformatted[naicsCode] === undefined) {
          // initiate data sturcture
          dataAPIreformatted[naicsCode] = {};
          dataAPIreformatted[naicsCode].id = Date.now(); // to create unique id for b-table refresh

          dataAPIreformatted[naicsCode].naics = dataAPI[0];
          dataAPIreformatted[naicsCode].sgc = {};
          dataAPIreformatted[naicsCode].wage_data = {};
        }

        dataAPIreformatted[naicsCode].sgc[dataAPI[1].code] = dataAPI[1];
        dataAPIreformatted[naicsCode].wage_data[`'${dataAPI[1].code}'`] = dataAPI[2];
      } //anonymous
      // now do check to merge all Naics in case user selection is 3-4 etc digits for naics


      var finalResult = {};
      let tempInput = payload.input; // eslint-disable-next-line prettier/prettier

      finalResult = copyWageData(finalResult, tempInput.mainNaics, dataAPIreformatted); // do same for compare Naics if exist

      if (tempInput.compare.naics.code) {
        // eslint-disable-next-line prettier/prettier
        finalResult = copyWageData(finalResult, tempInput.compare.naics, dataAPIreformatted);
      } // check for use case when compare sgc have not data
      // we manually add empty obj


      let compareSGCObj = tempInput.compare.sgc;
      let mainNaicsCode = tempInput.mainNaics.code;
      let compareNaicsCode = tempInput.compare.naics.code;

      if (compareSGCObj.code) {
        // eslint-disable-next-line prettier/prettier
        finalResult = setObjWhenNoData(context, tempInput, finalResult, mainNaicsCode, "location"); //for main naics

        if (compareNaicsCode) {
          // eslint-disable-next-line prettier/prettier
          finalResult = setObjWhenNoData(context, tempInput, finalResult, compareNaicsCode, "industry"); // for compare naics
        }
      }

      context.commit("updateWage", finalResult);
    }).catch(error => {
      // eslint-disable-next-line
      console.log(error);
      context.commit("updateError", true);
    });
  }
};

var actions = {
  getWageResults: function (context, payload) {
    Wage.getResults(context, payload, process.env.VUE_APP_NEO4J_URL, process.env.VUE_APP_NEO4J_USER, process.env.VUE_APP_NEO4J_PWD);
  }
};

// eslint-disable-next-line
var getters = {
  getWage: function (state) {
    return state.wage;
  },
  getInput: function (state) {
    return state.input;
  },
  getNoData: function (state) {
    return state.noData;
  },
  getError: function (state) {
    return state.error;
  }
};

var wages = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};

Vue.use(Vuex);
const store = new Vuex.Store({
  modules: {
    wages
  }
});

//
Vue.component("open-services-errors-component", OpenServicesErrorsComponent);
Vue.component("open-services-footer-component", OpenServicesFooterComponent);
Vue.component("open-services-naics-lookup", OpenServicesNaicsLookup);
Vue.component("open-services-sgc-lookup", OpenServicesSgcLookup); //store
var script = {
  i18n: {
    locale: "en",
    numberFormats: {
      "en-CA": {
        currency: {
          style: "currency",
          currency: "CAD",
          currencyDisplay: "symbol"
        }
      },
      "fr-CA": {
        currency: {
          style: "currency",
          currency: "CAD",
          currencyDisplay: "symbol"
        }
      }
    },
    messages: {
      en: {
        wage_title: "Median Hourly Full-time Wage",
        compare_both: "Compare with another location and/or industry",
        city_add: "City to add:",
        industry_label: "Industry",
        location_label: "Location",
        wage_label: "Median Wage",
        tooltip_excel: "Download table in Excel format",
        empty_both: "No current data for {location} and {industry}.",
        wage_title_industry: "Median Wage for {industry}",
        industry_add: "Industry to add:",
        prov_min_wage: "Current minimum wage for {province} is ${wage}.",
        no_compare_data: "Sorry, no compare data for that compare location with that industry.",
        try_another_compare: "Please try a different location or industry."
      },
      fr: {
        wage_title: "Salaire horaire médian à temps plein",
        compare_both: "Comparez avec un autre emplacement et/ou industrie",
        city_add: "Ville à ajouter :",
        industry_label: "Industrie",
        location_label: "Emplacement",
        wage_label: "Salaire médian",
        tooltip_excel: "Télécharger le tableau en format Excel",
        empty_both: "Aucune donnée courante pour {location} et {industry}",
        wage_title_industry: "Salaire médian pour {industry}",
        industry_add: "Industrie à ajouter :",
        prov_min_wage: "Salaire minimum actuel pour {province} est {wage} $.",
        no_compare_data: "Désolé, aucune donnée de comparaison pour cette emplacement de comparaison avec cette industrie.",
        try_another_compare: "Veuillez essayer un emplacement ou une industrie différent."
      }
    }
  },
  props: ["lang", "label", "data", "codeLocation", "location", "codeIndustry", "industry", "compareOption", "locationCompare", "industryCompare", "province", "minimumWage", "clearCompare"],
  store,
  mixins: [interaction],
  data: function () {
    return {
      scode: "",
      sname: "",
      ncode: "",
      nname: "",
      hasData: true,
      addComparisons: false,
      nocomparison: true,
      showGraph: true,
      locOpen: true,
      indOpen: true,
      //table formatting
      isPaginated: false,
      isPaginationSimple: false,
      defaultSortDirection: "asc",
      perPage: 5,
      isEmpty: false,
      isBordered: true,
      isStriped: true,
      isNarrowed: true,
      isLoading: true,
      hasMobileCards: true,
      //for download
      fileTable: "",
      wageData: [],
      json_meta: [[{
        key: "charset",
        value: "utf-8"
      }]],
      json_fields: {} // see mounted

    }; // end return
  },
  // end data
  components: {
    downloadExcel: JsonExcel
  },
  // end component
  mounted: function () {
    this.$i18n.locale = this.toggleLang;
    let today = new Date().toISOString().slice(0, 10);

    if (this.toggleLang === "fr") {
      this.fileTable = "Salaire-median_" + today + ".xls";
    } else {
      this.fileTable = "Median-wage_" + today + ".xls";
    }

    this.json_fields = {
      [this.$t("industry_label")]: "industry",
      [this.$t("location_label")]: "location",
      Occupation: "occupation",
      [this.$t("wage_label")]: {
        field: "wage",
        callback: value => {
          return `\n ${value}`;
        }
      }
    }; // end json_fields
  },
  // end mounted
  computed: { ...mapGetters("wages", ["getNoData", "getWage", "getInput", "getError"]),
    getLabel: function () {
      // return personalize label if entered else default label
      return this.label !== "" ? this.label : this.$t("wage_title");
    },
    toggleLang: function () {
      return this.lang;
    },
    toggleCompareOption: function () {
      return this.compareOption;
    },
    toggleSgcCompare: function () {
      if (this.locationCompare === "" || this.codeLocation === "" || this.codeIndustry === "" || this.clearCompare === true) {
        return "";
      } else {
        // eslint-disable-next-line
        this.addComparisons = true;
        return this.locationCompare;
      }
    },
    toggleNaicsCompare: function () {
      if (this.industryCompare === "" || this.codeLocation === "" || this.codeIndustry === "" || this.clearCompare === true) {
        return "";
      } else {
        // eslint-disable-next-line
        this.addComparisons = true;
        return this.industryCompare;
      }
    },
    error: function () {
      var error = this.$store.state.wages.error;
      return error;
    },
    jsonTableData: function () {
      //download data in Excel
      var exportData = [];
      let wageData = this.wageData[0];

      for (var index in wageData) {
        const mydata = this.transformData(wageData[index]);

        for (var code in wageData[index].wage_data) {
          for (var row in mydata) {
            //push info in table
            exportData.push({
              industry: wageData[index].naics.name,
              location: this.getLocationTitle(wageData[index].sgc, code),
              occupation: mydata[row].title,
              wage: this.getWageValue(code, mydata[row])
            });
          }
        }
      }

      return exportData;
    },
    //end jsonTablePermitData
    getWateData: function () {
      // to make it for developer site
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.wageData = this.getWage;
      return this.wageData;
    }
  },
  // end computed
  watch: {
    lang: function () {
      this.$i18n.locale = this.toggleLang;
    },
    codeLocation: function () {
      // reset compare SGC/NAICS
      this.resetCompare();
      this.addComparisons = false;
    },
    // end codeLocation
    codeIndustry: function () {
      // reset compare SGC/NAICS
      this.resetCompare();
      this.addComparisons = false;
    },
    // end codeIndustry
    addComparisons: function () {
      if (!this.addComparisons) {
        // reset compare SGC/NAICS
        this.resetCompare();
      }
    },
    // end addComparaisons
    data: function () {
      let wageData = this.data[0];

      for (const ind in wageData) {
        // if no main data, hide compare box
        if (Object.entries(wageData[ind].sgc).length === 0 && !this.addComparisons) {
          this.hasData = false;
        } else {
          this.hasData = true;
        }
      }
    } // end data

  },
  // end watch
  methods: { ...mapMutations("wages", ["updateCompareInput", "resetCompareInput", "updateError"]),
    getLocationTitle: function (sgcObj, sgcCode) {
      let sgcWithoutSingleQuote = sgcCode.split("'").join("");

      if (this.toggleLang === "en") {
        // eslint-disable-next-line prettier/prettier
        return sgcObj[parseInt(sgcWithoutSingleQuote)] ? sgcObj[parseInt(sgcWithoutSingleQuote)].title_en : "";
      } else {
        // eslint-disable-next-line prettier/prettier
        return sgcObj[parseInt(sgcWithoutSingleQuote)] ? sgcObj[parseInt(sgcWithoutSingleQuote)].title_fr : "";
      }
    },
    // end getLocationTitle
    resetCompare: function () {
      // set compare SGC and Naics to empty
      if (this.$refs.compLoc) {
        this.$refs.compLoc.selected = "";
      }

      if (this.$refs.compInd) {
        this.$refs.compInd.selected = "";
      }

      this.resetCompareInput();
    },
    // end resetCompare
    setOpen: function (index, data) {
      // index = use to tell the number Naics
      let sizeData = Object.keys(data).length;

      if (index == sizeData - 1) {
        return true;
      } else {
        return false;
      }
    },
    // end setOpen
    insertHighlight: function (code, flag) {
      if (flag == "location") {
        return code === this.scode ? "highlight" : "";
      } else {
        return code === `'${this.ncode}'` ? "highlight" : "";
      } // index = use to tell the number of Sgc or Naics

      /*
      let sizeData = Object.keys(data).length;
      if (index == sizeData - 1 && index != 0) {
        return "highlight";
      } else {
        return "";
      }
      */

    },
    // end insertHighlight
    changeSgcCallback: async function (event) {
      if (event.sgc != null) {
        for (var elements in event.sgc) {
          this.scode = event.sgc[elements].code;
          this.sname = event.sgc[elements].name;
        }

        if (event.sgc.length === 0) {
          this.scode = "";
          this.sname = "";
        }

        await this.updateCompareInput({
          key: "sgc",
          payload: {
            name: this.sname,
            code: this.scode
          }
        });
      }
    },
    // end changeSgcCallback
    changeNaicsCallback: async function (event) {
      this.indOpen = false;

      if (event.naics != null) {
        for (var elementn in event.naics) {
          this.ncode = event.naics[elementn].code;
          this.nname = event.naics[elementn].name;
        }

        if (event.naics.length === 0) {
          this.ncode = "";
          this.nname = "";
        }

        await this.updateCompareInput({
          key: "naics",
          payload: {
            name: this.nname,
            code: this.ncode
          }
        });
      }
    },
    // end changeNaicsCallback
    transformData: function (data) {
      // Transform Data for Data Table
      var tableData = {};

      for (const key in data.sgc) {
        //to remove the single quote in key
        let keyWithoutSingleQuote = key.split("'").join("");
        let tempData = data.wage_data[`'${key}'`];

        for (let myIndex = 0; myIndex < tempData.length; myIndex++) {
          let tempWage = tempData[myIndex];

          if (tableData[tempWage.noc_code] === undefined) {
            tableData[tempWage.noc_code] = {
              title: this.toggleLang === "en" ? tempWage.title_en : tempWage.title_fr,
              noc_code: tempWage.noc_code
            };
            tableData[tempWage.noc_code][`wage-${keyWithoutSingleQuote}`] = tempWage.wage;
          } else {
            tableData[tempWage.noc_code][`wage-${keyWithoutSingleQuote}`] = tempWage.wage;
          }
        } //for2

      } //for
      //console.log("objecs.value")
      //console.log(Object.values(tableData));


      return Object.values(tableData);
    },
    // end transformData
    getWageValue: function (sgcCode, data) {
      //to remove the single quote in key
      let sgcWithoutSingleQuote = sgcCode.split("'").join("");
      let tempIndex = `wage-${sgcWithoutSingleQuote}`;
      let value = data[tempIndex];

      if (value === undefined) {
        value = this.toggleLang === "en" ? "n/a" : "s.o.";
        return value;
      }

      return this.toggleLang === "en" ? this.$n(value, "currency", "en-CA") : this.$n(value, "currency", "fr-CA");
    },
    // end getWageValue
    trackDownload: function () {
      // save interaction
      let tempInput = this.getInput; // eslint-disable-next-line prettier/prettier

      let compareSgc = tempInput.compare.sgc.code == "" ? "notset" : tempInput.compare.sgc.code; // eslint-disable-next-line prettier/prettier

      let compareNaics = tempInput.compare.naics.code == "" ? "notset" : tempInput.compare.naics.code; // save interaction, here we save relationship to SGC/SGC compare and NAICS/NAics compare

      let propsInteraction = this.mxGetDefaultInteractionProp(this.toggleLang, "Wage - download Excel - Widget", tempInput.mainSgc, tempInput.mainNaics);
      let statementInteraction = this.mxCreateNodeStatement("n", this.mxInteraction.label, propsInteraction); // create Merge relationship Interaction and UserDate

      let statementRelationshipDate = this.mxCreateDateMergeRelationshipDate(propsInteraction.key, propsInteraction.timestamp_readable); // create statement for Main SGC relationship with interaction

      let statementRelationshipMainSGC = this.mxCreateInteractionRelationshipStatement(this.mxInteraction.label, propsInteraction.key, this.mxLocation.relationship, this.mxLocation.label, this.mxLocation.properties.sgc_code, [tempInput.mainSgc.code], true); // create statement for compare SGC relationship with interaction

      let statementRelationshipCompareSGC = this.mxCreateInteractionRelationshipStatement(this.mxInteraction.label, propsInteraction.key, "INTERACT_COMPARE", this.mxLocation.label, this.mxLocation.properties.sgc_code, [compareSgc], true); // create statement for Main NAICS relationship with interaction

      let statementRelationshipMainNAICS = this.mxCreateInteractionRelationshipStatement(this.mxInteraction.label, propsInteraction.key, this.mxIndustry.relationship, this.mxIndustry.label, this.mxIndustry.properties.naics_code, [tempInput.mainNaics.code], true); // create statement for compare NAICS relationship with interaction

      let statementRelationshipCompareNAICS = this.mxCreateInteractionRelationshipStatement(this.mxInteraction.label, propsInteraction.key, "INTERACT_COMPARE", this.mxIndustry.label, this.mxIndustry.properties.naics_code, [compareNaics], true); //from mixin

      this.mxSaveInteraction(process.env.VUE_APP_NEO4J_URL, process.env.VUE_APP_NEO4J_USER, process.env.VUE_APP_NEO4J_PWD, [statementInteraction, statementRelationshipMainSGC, statementRelationshipCompareSGC, statementRelationshipMainNAICS, statementRelationshipCompareNAICS, statementRelationshipDate]);
    },
    simulateClick: function (refName) {
      this.$refs[refName].$el.click();
    },
    collapseToggle: function (refName) {
      this.$refs[refName][0].toggle();
    }
  } // end method

}; // end export default

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('span', {
    staticClass: "is-size-4"
  }, [_c('b-icon', {
    staticClass: "is-medium",
    attrs: {
      "icon": "table",
      "pack": "fas"
    }
  })], 1), _vm._v(" " + _vm._s(_vm.getLabel) + "\n    ")])]), _vm._v(" "), _vm.error ? _c('div', {
    staticClass: "error"
  }, [_c('open-services-errors-component', {
    attrs: {
      "lang": _vm.toggleLang
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.toggleCompareOption && !_vm.error ? _c('div', {
    attrs: {
      "id": "compareoption"
    }
  }, [_vm.hasData ? _c('div', {
    staticClass: "compareBox columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('b-checkbox', {
    attrs: {
      "type": "is-info"
    },
    model: {
      value: _vm.addComparisons,
      callback: function ($$v) {
        _vm.addComparisons = $$v;
      },
      expression: "addComparisons"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("compare_both")) + "\n          ")])], 1)])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.addComparisons,
      expression: "addComparisons"
    }],
    staticClass: "columns",
    attrs: {
      "id": "addcomparisons"
    }
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("city_add")) + "\n          "), _c('open-services-sgc-lookup', {
    ref: "compLoc",
    attrs: {
      "id": "sgcCompareWage",
      "lang": _vm.toggleLang,
      "show-label": false,
      "has-source": false,
      "input-code": _vm.toggleSgcCompare
    },
    on: {
      "change": _vm.changeSgcCallback
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("industry_add")) + "\n          "), _c('open-services-naics-lookup', {
    ref: "compInd",
    attrs: {
      "id": "naicsCompareWage",
      "lang": _vm.toggleLang,
      "show-label": false,
      "has-source": false,
      "input-code": _vm.toggleNaicsCompare
    },
    on: {
      "change": _vm.changeNaicsCallback
    }
  }), _vm._v(" "), _c('br')], 1)])]), _vm._v(" "), _c('div', [_c('b-notification', {
    attrs: {
      "type": "is-danger",
      "active": _vm.getNoData,
      "has-icon": "",
      "icon-pack": "fas",
      "aria-close-label": "Close notification",
      "role": "alert"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("no_compare_data")) + "\n        "), _c('br'), _vm._v("\n        " + _vm._s(_vm.$t("try_another_compare")) + "\n      ")]), _vm._v(" "), _c('br')], 1)], 1) : _vm._e(), _vm._v(" "), _vm.hasData && !_vm.error ? _c('div', {
    staticClass: "column has-text-right",
    attrs: {
      "id": "hasdata"
    }
  }, [_c('b-tooltip', {
    attrs: {
      "type": "is-info",
      "position": "is-left",
      "label": _vm.$t('tooltip_excel')
    }
  }, [_c('downloadExcel', {
    staticClass: "button",
    attrs: {
      "data": _vm.jsonTableData,
      "fields": _vm.json_fields,
      "meta": _vm.json_meta,
      "name": _vm.fileTable,
      "data-toggle": "tooltip",
      "title": _vm.$t('wage_title'),
      "before-finish": _vm.trackDownload
    }
  }, [_c('b-icon', {
    ref: "downloadIcon",
    staticClass: "is-medium",
    attrs: {
      "tabindex": "0",
      "icon": "download",
      "pack": "fas",
      "type": "is-info",
      "aria-label": _vm.$t('tooltip_excel')
    },
    nativeOn: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.simulateClick('downloadIcon');
      }
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l(_vm.getWateData[0], function (Data, key, id) {
    return _c('div', {
      key: Data.id
    }, [_c('b-collapse', {
      ref: "collapse" + key,
      refInFor: true,
      staticClass: "card",
      attrs: {
        "open": _vm.setOpen(id, _vm.data[0]),
        "animation": "myCustomSlide",
        "aria-id": "nocomparison"
      },
      scopedSlots: _vm._u([{
        key: "trigger",
        fn: function (indOpen) {
          return _c('div', {
            staticClass: "card-header",
            class: _vm.insertHighlight(key, 'industry'),
            attrs: {
              "role": "button",
              "aria-controls": "nocomparison",
              "tabindex": "0"
            },
            on: {
              "keyup": function ($event) {
                if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
                  return null;
                }

                return _vm.collapseToggle("collapse" + key);
              }
            }
          }, [_c('p', {
            staticClass: "card-header-title"
          }, [_c('i18n', {
            attrs: {
              "path": "wage_title_industry",
              "tag": "h1"
            },
            scopedSlots: _vm._u([{
              key: "industry",
              fn: function () {
                return [_c('b', [_vm._v(_vm._s(Data.naics.name))])];
              },
              proxy: true
            }], null, true)
          })], 1), _vm._v(" "), _c('a', {
            staticClass: "card-header-icon"
          }, [_c('b-icon', {
            attrs: {
              "pack": "fas",
              "type": "is-info",
              "icon": indOpen.open ? 'chevron-circle-down' : 'chevron-circle-up'
            }
          })], 1)]);
        }
      }], null, true)
    }, [_vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('b-table', {
      attrs: {
        "data": _vm.isEmpty ? [] : _vm.transformData(Data),
        "paginated": _vm.isPaginated,
        "per-page": _vm.perPage,
        "pagination-simple": _vm.isPaginationSimple,
        "default-sort-direction": _vm.defaultSortDirection,
        "default-sort": "title",
        "striped": _vm.isStriped,
        "narrowed": _vm.isNarrowed,
        "mobile-cards": _vm.hasMobileCards,
        "icon-pack": "fas"
      }
    }, [_c('b-table-column', {
      attrs: {
        "field": "title",
        "label": "Occupation",
        "sortable": ""
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function (props) {
          return [_vm._v("\n              " + _vm._s(props.row.title) + "\n            ")];
        }
      }], null, true)
    }), _vm._v(" "), _vm._l(Data.sgc, function (sgcObj, sgcCode) {
      return _c('b-table-column', {
        key: sgcObj.code,
        class: _vm.insertHighlight(sgcObj.code, 'location'),
        attrs: {
          "label": _vm.getLocationTitle(Data.sgc, sgcCode),
          "field": sgcObj.code,
          "width": "150",
          "centered": "",
          "header-class": _vm.insertHighlight(sgcObj.code, 'location')
        },
        scopedSlots: _vm._u([{
          key: "default",
          fn: function (props) {
            return [_vm._v("\n              " + _vm._s(_vm.getWageValue(sgcCode, props.row)) + "\n            ")];
          }
        }], null, true)
      });
    }), _vm._v(" "), _c('template', {
      slot: "empty"
    }, [_c('div', {
      staticClass: "has-text-grey has-text-centered"
    }, [_c('div', {
      staticClass: "section"
    }, [_c('p', [_c('b-icon', {
      attrs: {
        "pack": "fas",
        "icon": "frown",
        "size": "is-large"
      }
    })], 1), _vm._v(" "), _c('i18n', {
      attrs: {
        "path": "empty_both",
        "tag": "p"
      },
      scopedSlots: _vm._u([{
        key: "location",
        fn: function () {
          return [_c('b', [_vm._v(_vm._s(_vm.location))])];
        },
        proxy: true
      }, {
        key: "industry",
        fn: function () {
          return [_c('b', [_vm._v(_vm._s(Data.naics.name))])];
        },
        proxy: true
      }], null, true)
    }), _vm._v(" "), _c('i18n', {
      attrs: {
        "path": "prov_min_wage",
        "tag": "p"
      },
      scopedSlots: _vm._u([{
        key: "province",
        fn: function () {
          return [_c('b', [_vm._v(_vm._s(_vm.province.prov))])];
        },
        proxy: true
      }, {
        key: "wage",
        fn: function () {
          return [_c('b', [_vm._v(_vm._s(_vm.minimumWage))])];
        },
        proxy: true
      }], null, true)
    })], 1)])])], 2)], 1)])])], 1);
  }), _vm._v(" "), _c('footer', [_c('open-services-footer-component', {
    attrs: {
      "lang": _vm.toggleLang,
      "widget": "wage"
    }
  })], 1)], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-d4049510_0", {
    source: ".wage-widget .collapse{display:block!important}.wage-widget .card-header{padding:0!important}.wage-widget .footer{display:block!important}.wage-widget .compareBox{padding-top:15px}.wage-widget .notification{padding-top:5px!important;padding-bottom:5px!important}.wage-widget .highlight{background-color:transparent;animation-name:background;animation-duration:4s;animation-delay:-2s;animation-timing-function:linear;-webkit-animation-name:background;-webkit-animation-duration:4s;-webkit-animation-delay:-2s;-webkit-animation-timing-function:linear;-moz-animation-name:background;-moz-animation-duration:4s;-moz-animation-delay:-2s;-moz-animation-timing-function:linear;-ms-animation-name:background;-ms-animation-duration:4s;-ms-animation-delay:-2s;-ms-animation-timing-function:linear}@keyframes background{from{background-color:transparent}to{background-color:#ffd}}@-webkit-keyframes background{from{background-color:transparent}to{background-color:#ffd}}@-moz-keyframes background{from{background-color:transparent}to{background-color:#ffd}}@-ms-keyframes background{from{background-color:transparent}to{background-color:#ffd}}.wage-widget .fade-leave-active{animation:fadeOut ease-out .5s;-webkit-animation:fadeOut ease-out .5s;-moz-animation:fadeOut ease-out .5s;-o-animation:fadeOut ease-out .5s;-ms-animation:fadeOut ease-out .5s}@keyframes fadeOut{0%{opacity:1}100%{opacity:0}}@-moz-keyframes fadeOut{0%{opacity:1}100%{opacity:0}}@-webkit-keyframes fadeOut{0%{opacity:1}100%{opacity:0}}@-o-keyframes fadeOut{0%{opacity:1}100%{opacity:0}}@-ms-keyframes fadeOut{0%{opacity:1}100%{opacity:0}}.wage-widget .fade-enter,.wage-widget .fade-leave-to{opacity:0}.wage-widget .fade-enter-active{animation:fadeIn ease-in .5s;-webkit-animation:fadeIn ease-in .5s;-moz-animation:fadeIn ease-in .5s;-o-animation:fadeIn ease-in .5s;-ms-animation:fadeIn ease-in .5s}@keyframes fadeIn{0%{opacity:0}100%{opacity:1}}@-moz-keyframes fadeIn{0%{opacity:0}100%{opacity:1}}@-webkit-keyframes fadeIn{0%{opacity:0}100%{opacity:1}}@-o-keyframes fadeIn{0%{opacity:0}100%{opacity:1}}@-ms-keyframes fadeIn{0%{opacity:0}100%{opacity:1}}.wage-widget .myCustomSlide-enter-active,.wage-widget .myCustomSlide-leave-active{max-height:230px;overflow-y:hidden;-webkit-transition:max-height 2.5s ease;-moz-transition:max-height 2.5s ease;-o-transition:max-height 2.5s ease;transition:max-height 2.5s ease}.wage-widget .myCustomSlide-enter-active{max-height:600px}.wage-widget .myCustomSlide-enter{opacity:.5;max-height:0}.wage-widget .myCustomSlide-leave-to{opacity:.5;max-height:0}@media only screen and (max-device-width:480px){.wage-widget .box{padding:.3rem}.wage-widget .card-content{padding:.1rem}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__ = undefined;
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

//
Vue.component("open-services-errors-component", OpenServicesErrorsComponent);
Vue.component("open-services-footer-component", OpenServicesFooterComponent);
Vue.component("open-services-naics-lookup", OpenServicesNaicsLookup);
Vue.component("open-services-sgc-lookup", OpenServicesSgcLookup); //store
library.add(faExclamationCircle, faChevronCircleDown, faChevronCircleUp, faTable, faFrown, faDownload, faArrowUp, faArrowDown);
Vue.component("font-awesome-icon", FontAwesomeIcon); // buefy
Vue.use(Notification);
Vue.use(Collapse);
Vue.use(Table);
Vue.use(Checkbox);
Vue.use(Tooltip);
Vue.use(Icon);
ConfigProgrammatic.setOptions({
  defaultIconComponent: "vue-fontawesome",
  defaultIconPack: "fas"
}); // language
Vue.use(VueI18nWage);
const numberFormats = {
  "en-CA": {
    currency: {
      style: "currency",
      currency: "CAD"
    }
  },
  "fr-CA": {
    currency: {
      style: "currency",
      currency: "CAD"
    }
  }
}; // Create VueI18n instance with options

new VueI18nWage({
  locale: "en",
  numberFormats
});
var script$1 = {
  name: 'OpenServicesWageWidget',
  // vue component name
  i18n: {
    locale: "en",
    messages: {
      en: {
        required_bolded: "Location and Industry",
        required_text: "{bold} is required to show the Median Hourly Full-time Wage."
      },
      fr: {
        required_bolded: "Emplacement et industrie",
        required_text: "{bold} sont requis pour afficher Salaire horaire médian à temps plein."
      }
    }
  },
  props: {
    lang: {
      type: String,
      default: "en"
    },
    sgcCode: {
      type: String,
      default: ""
    },
    naicsCode: {
      type: String,
      default: ""
    },
    sgcCompare: {
      type: String,
      default: ""
    },
    naicsCompare: {
      type: String,
      default: ""
    },
    showInputs: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ""
    },
    compareOption: {
      type: Boolean,
      default: true
    }
  },
  store,
  mixins: [interaction],
  data: function () {
    return {
      mysgcCode: "",
      mysgcName: "",
      mynaicsCode: "",
      mynaicsName: "",
      clearCompare: false,
      hasWageData: false
    };
  },
  // end data
  components: {
    "wage-app": __vue_component__
  },
  // components
  mounted: function () {
    this.$i18n.locale = this.toggleLang; //have to setup watcher here to make it
    // works for developer site
    // eslint-disable-next-line prettier/prettier

    this.$store.watch(() => store.getters["wages/getInput"], input => {
      let copyInput = JSON.parse(JSON.stringify(input));
      this.updateData(copyInput);
    }, {
      deep: true
    });
  },
  // end mounted
  computed: { ...mapGetters("wages", ["getWage", "getInput"]),
    toggleLang: function () {
      return this.lang;
    },
    toggleShowInputs: function () {
      return this.showInputs;
    },
    toggleCompareOption: function () {
      return this.compareOption;
    },
    toggleSgcInputCode: function () {
      if (this.sgcCode === "") {
        return "";
      } else {
        return this.sgcCode;
      }
    },
    toggleNaicsInputCode: function () {
      if (this.naicsCode === "") {
        return "";
      } else {
        return this.naicsCode;
      }
    },
    toggleSgcCompare: function () {
      return this.sgcCompare;
    },
    toggleNaicsCompare: function () {
      return this.naicsCompare;
    },
    toggleLabel: function () {
      return this.label;
    },
    prov: function () {
      return this.getProv(this.mysgcCode);
    },
    minimum: function () {
      return this.getMinimumWage(this.mysgcCode);
    }
  },
  // end computed
  watch: {
    lang: function () {
      this.$i18n.locale = this.toggleLang;
    },
    mysgcCode: function () {
      if (this.mysgcCode === "") {
        this.clearCompare = true;
        this.resetCompareInput();
        this.hasWageData = false;
      }
    },
    mynaicsCode: function () {
      if (this.mynaicsCode === "") {
        this.clearCompare = true;
        this.resetCompareInput();
        this.hasWageData = false;
      }
    }
  },
  // end watch
  methods: { ...mapActions("wages", ["getWageResults"]),
    ...mapMutations("wages", ["updateWage", "updateMainInput", "updateCompareInput", "resetCompareInput"]),
    changeLocationCallback: async function (event) {
      if (event.sgc != null) {
        for (var els in event.sgc) {
          this.mysgcCode = event.sgc[els].code;
          this.mysgcName = event.sgc[els].name;
        }

        if (event.sgc.length === 0) {
          this.mysgcCode = "";
          this.mysgcName = "";
        }

        await this.updateMainInput({
          key: "mainSgc",
          payload: {
            name: this.mysgcName,
            code: this.mysgcCode
          }
        });
      }
    },
    // end changeLocationCallback
    changeIndustryCallback: async function (event) {
      if (event.naics != null) {
        for (var eln in event.naics) {
          this.mynaicsCode = event.naics[eln].code;
          this.mynaicsName = event.naics[eln].name;
        }

        if (event.naics.length === 0) {
          this.mynaicsCode = "";
          this.mynaicsName = "";
        }

        await this.updateMainInput({
          key: "mainNaics",
          payload: {
            name: this.mynaicsName,
            code: this.mynaicsCode
          }
        });
      }
    },

    // end changeIndustryCallback
    // get province code and name from sgc code
    getProv(sgc) {
      var sgcCity = "";
      var levelDigit = "";
      var sgcProv = "1";
      var prov = "Canada";

      if (sgc) {
        sgcCity = sgc;
        levelDigit = sgcCity.toString().length;

        if (levelDigit == 1) {
          sgcProv = "1";
        } else {
          sgcProv = sgcCity.toString().substr(0, 2);
        }

        if (this.toggleLang === "fr") {
          prov = this.$store.state.wages.provLookupFr[sgcProv];
        } else {
          prov = this.$store.state.wages.provLookupEn[sgcProv];
        }
      }

      return {
        sgcProv,
        prov
      };
    },

    // get minimum wage from sgc code
    getMinimumWage(sgc) {
      var wage = 0;
      var prov = "1";
      var sgcLevel = 1;

      if (sgc) {
        sgcLevel = sgc.toString().length;

        if (sgcLevel > 1) {
          prov = sgc.toString().substr(0, 2);
          wage = this.$store.state.wages.minimumWage[prov];
        }
      }

      if (this.toggleLang === "fr") {
        return wage.replace(".", ",");
      } else {
        return wage;
      }
    },

    updateData: function (input) {
      let tempInput = input;

      if (tempInput.mainSgc.code !== "" && tempInput.mainNaics.code !== "") {
        let compareSgc = tempInput.compare.sgc.code === "" ? "notset" : tempInput.compare.sgc.code;
        let compareNaics = tempInput.compare.naics.code === "" ? "notset" : tempInput.compare.naics.code;
        let dataYear = process.env.VUE_APP_WAGE_YEAR || "2019";
        let req = `MATCH (n:Location)-[*1..2]-(wage:AvgFulltimeHourlyWage)-[]-(noc:Occupation)-[]-(m:Industry) where ((n.sgc_code starts with "${tempInput.mainSgc.code}" OR n.sgc_code starts with "${compareSgc}" ) AND (m.naics_code starts with "${tempInput.mainNaics.code}" OR m.naics_code starts with "${compareNaics}")) 
          WITH noc,wage,
              {
                naics_code:m.naics_code,
                title_en:m.title,
                title_fr:m.title_fr
               } as Naics,
               {
                  code:n.sgc_code,
                   title_en:n.title,
                   title_fr:n.title_fr
                } as SGC
              ORDER BY noc.title ASC
              where exists(wage.wage_${dataYear})  
              return Naics, SGC,collect({title_en:noc.title,title_fr:noc.title_fr,wage:wage.wage_${dataYear},noc_code:noc.noc_code}) as Data       
          `; //console.log(req)

        this.getWageResults({
          req: req,
          input: tempInput
        });
        this.hasWageData = true; // save interaction, here we save relationship to SGC/SGC compare and NAICS/NAics compare

        let propsInteraction = this.mxGetDefaultInteractionProp(this.toggleLang, "Wage - Widget", tempInput.mainSgc, tempInput.mainNaics);
        let statementInteraction = this.mxCreateNodeStatement("n", this.mxInteraction.label, propsInteraction); // create Merge relationship Interaction and UserDate

        let statementRelationshipDate = this.mxCreateDateMergeRelationshipDate(propsInteraction.key, propsInteraction.timestamp_readable); // create statement for Main SGC relationship with interaction

        let statementRelationshipMainSGC = this.mxCreateInteractionRelationshipStatement(this.mxInteraction.label, propsInteraction.key, this.mxLocation.relationship, this.mxLocation.label, this.mxLocation.properties.sgc_code, [tempInput.mainSgc.code], true); // create statement for compare SGC relationship with interaction

        let statementRelationshipCompareSGC = this.mxCreateInteractionRelationshipStatement(this.mxInteraction.label, propsInteraction.key, "INTERACT_COMPARE", this.mxLocation.label, this.mxLocation.properties.sgc_code, [compareSgc], true); // create statement for Main NAICS relationship with interaction

        let statementRelationshipMainNAICS = this.mxCreateInteractionRelationshipStatement(this.mxInteraction.label, propsInteraction.key, this.mxIndustry.relationship, this.mxIndustry.label, this.mxIndustry.properties.naics_code, [tempInput.mainNaics.code], true); // create statement for compare NAICS relationship with interaction

        let statementRelationshipCompareNAICS = this.mxCreateInteractionRelationshipStatement(this.mxInteraction.label, propsInteraction.key, "INTERACT_COMPARE", this.mxIndustry.label, this.mxIndustry.properties.naics_code, [compareNaics], true); //from mixin

        this.mxSaveInteraction(process.env.VUE_APP_NEO4J_URL, process.env.VUE_APP_NEO4J_USER, process.env.VUE_APP_NEO4J_PWD, [statementInteraction, statementRelationshipMainSGC, statementRelationshipCompareSGC, statementRelationshipMainNAICS, statementRelationshipCompareNAICS, statementRelationshipDate]);
      } else if (this.mysgcCode !== "" && this.mynaicsCode === "") {
        this.hasWageData = false;
      } else if (this.mysgcCode === "" && this.mynaicsCode !== "") {
        this.hasWageData = false;
      } else {
        this.hasWageData = false;
      }
    } // end updateData

  } // end methods

}; // end export default

/* script */
const __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "wage-widget container",
    attrs: {
      "id": "wage-tab-content"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.toggleShowInputs,
      expression: "toggleShowInputs"
    }],
    staticClass: "columns",
    attrs: {
      "id": "showinputs"
    }
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('open-services-sgc-lookup', {
    ref: "topLoc",
    attrs: {
      "id": "toplocation",
      "multiple": false,
      "lang": _vm.toggleLang,
      "show-label": true,
      "has-source": false,
      "input-code": _vm.toggleSgcInputCode
    },
    on: {
      "change": _vm.changeLocationCallback
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('open-services-naics-lookup', {
    ref: "topInd",
    attrs: {
      "id": "topindustry",
      "multiple": false,
      "lang": _vm.toggleLang,
      "show-label": true,
      "has-source": false,
      "input-code": _vm.toggleNaicsInputCode
    },
    on: {
      "change": _vm.changeIndustryCallback
    }
  })], 1)]), _vm._v(" "), _vm.hasWageData ? _c('div', {
    attrs: {
      "id": "haswagedata"
    }
  }, [_c('wage-app', {
    attrs: {
      "lang": _vm.toggleLang,
      "label": _vm.toggleLabel,
      "data": _vm.getWage,
      "code-location": _vm.mysgcCode,
      "location": _vm.mysgcName,
      "code-industry": _vm.mynaicsCode,
      "industry": _vm.mynaicsName,
      "compare-option": _vm.toggleCompareOption,
      "location-compare": _vm.toggleSgcCompare,
      "industry-compare": _vm.toggleNaicsCompare,
      "province": _vm.prov,
      "minimumWage": _vm.minimum,
      "clear-compare": _vm.clearCompare
    }
  })], 1) : _c('div', [_c('i18n', {
    attrs: {
      "path": "required_text",
      "tag": "p"
    },
    scopedSlots: _vm._u([{
      key: "bold",
      fn: function () {
        return [_c('b', [_vm._v(_vm._s(_vm.$t("required_bolded")))])];
      },
      proxy: true
    }])
  })], 1)]);
};

var __vue_staticRenderFns__$1 = [];
/* style */

const __vue_inject_styles__$1 = function (inject) {
  if (!inject) return;
  inject("data-v-91324630_0", {
    source: ".wage-widget .card-footer-header{background:#fafafa}.wage-widget .card-footer-header .columns{margin:0}.wage-widget .card-footer-header .column{border:none!important}.wage-widget .card-footer-item{background:#f8f8f8;justify-content:left!important;padding-left:1.5em;padding-right:.75em;border:none!important;opacity:.8}.wage-widget .card-footer-item span.flink{display:inline-block;margin-right:1.6em}.wage-widget .card-footer-item a{text-decoration:underline}.wage-widget .card-footer-content{background:#fafafa!important;padding-left:1.5em!important;padding-right:1.5em!important;padding-top:0!important;padding-bottom:1.5em!important}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1 = undefined;
/* module identifier */

const __vue_module_identifier__$1 = undefined;
/* functional template */

const __vue_is_functional_template__$1 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, createInjector, undefined, undefined);

// Import vue component

const install = function installOpenServicesWageWidget(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('OpenServicesWageWidget', __vue_component__$1);
}; // Create module definition for Vue.use()
// to be registered via Vue.use() as well as Vue.component()


__vue_component__$1.install = install; // Export component by default
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export default __vue_component__$1;
